module.exports = __webpack_public_path__ + "img/m-en.bc1ef606.png";